import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { BdAuthenticationService } from '@bindoc-projects/security-lib/data';
import { BdSecurityAuthenticationLoginFailedComponent } from './authentification-login-failed.component';
import { RouterModule } from '@angular/router';

@NgModule({
  exports: [
    MsalModule,
    BdSecurityAuthenticationLoginFailedComponent,
    RouterModule,
  ],
  imports: [
    MsalModule,
    RouterModule.forChild([
      {
        path: 'sys-login-failed',
        component: BdSecurityAuthenticationLoginFailedComponent,
      },
    ]),
    BdSecurityAuthenticationLoginFailedComponent,
  ],
  providers: [
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class BdAuthenticationModule {
  private _authenticationService = inject(BdAuthenticationService);
}
